module.exports = __webpack_public_path__ + "img/icon_chevron_down.a7e630ec.svg";